import { useState } from 'react';
import styled from 'styled-components';
import { SizePicker } from '@components/products';

const DesktopBuyMenu = ({
    product,
    selectedSize,
    setSelectedSize,
    openInfoModal,
    openReturnPolicyModal,
    discountRate,
    setShowError,
    showError,
    setVariantQuantity,
    variantQuantity,
}) => {
    const [showWarning, setShowWarning] = useState(false);
    const [stockModalValue, setStockModalValue] = useState(false);

    const {
        sizes,
        stock,
        id,
        price,
        discounted_price: discountedPrice,
    } = product;

    return (
        <SizeWrapper>
            <SizePicker
                hideButton
                sizes={sizes}
                stock={stock}
                modelID={id}
                selectedSize={selectedSize}
                setSelectedSize={setSelectedSize}
                price={price}
                discountedPrice={discountedPrice}
                discountRate={discountRate}
                product={product}
                openInfoModal={openInfoModal}
                openReturnPolicyModal={openReturnPolicyModal}
                setShowWarning={setShowWarning}
                showWarning={showWarning}
                showError={showError}
                setShowError={setShowError}
                stockModalValue={stockModalValue}
                setVariantQuantity={setVariantQuantity}
                variantQuantity={variantQuantity}
                setStockModalValue={setStockModalValue}
            />
        </SizeWrapper>
    );
};

const SizeWrapper = styled.div`
    width: 100%;

    @media (max-width: 1024px) {
        display: none;
    }
`;
export default DesktopBuyMenu;
